






import { Component } from 'vue-property-decorator';
import SuperviseServices from '@/services/supervise';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { sleep } from '@/libs/util';
@Component({
  components: {}
})
export default class ScrollBoard extends mixins(DictMixin) {
  superSrv = new SuperviseServices();

  created() {
    this.getList();
  }

  config: any = {
    header: ['预警日期', '预警等级', '预警信息', '经办人/经办状态', '复核人/复核状态'],
    data: [],
    index: true,
    columnWidth: [100, 150, 200, 400, 200, 200],
    align: ['center'],
    rowNum: 7,
    headerBGC: '#1981f6',
    headerHeight: 45,
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)'
  };

  async getList() {
    if (!this.SYS_DICT.DICT_ALERT_LEVEL) {
      await sleep(100);
      this.getList();
      return false;
    }
    let res = await this.superSrv.getList({ page: 1, limit: 20 });
    this.config.data = res.list.map((v: any) => {
      let { alertDate, alertLevel, alertMessage, alertHandlerName, alertHandleStatusCn, alertReviewerName, alertReviewStatusCn } = v.sourceAsMap;
      return [
        alertDate,
        this.DICT_VALUE('DICT_ALERT_LEVEL', alertLevel),
        alertMessage,
        `${alertHandlerName || '未指定'}/${alertHandleStatusCn}`,
        `${alertReviewerName || '未指定'}/${alertReviewStatusCn}`
      ];
    });
  }
}
